import React, { useState } from 'react';
import { FaSave, FaTimes, FaCheckCircle, FaFilePdf, FaBuilding, FaUserTie } from 'react-icons/fa';

const DelawareLLCChecklistForm = ({ initialData, onSave, onCancel, isSubmitting }) => {
  const defaultData = {
    companyName: '',
    taxYear: new Date().getFullYear().toString(),
    raName: '',
    raAddress: '',
    raCity: '',
    raState: 'Delaware',
    raZipCode: ''
  };

  const [formData, setFormData] = useState({
    ...defaultData,
    ...(initialData || {})
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData, true);
  };

  return (
    <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-xl overflow-hidden border border-gray-100 dark:border-dark-700">
      <div className="p-6 border-b border-gray-100 dark:border-dark-700 flex justify-between items-center bg-gradient-to-r from-indigo-600 to-violet-600">
        <h2 className="text-xl font-bold text-white flex items-center gap-2">
          <FaCheckCircle /> Delaware LLC Annual Report Checklist
        </h2>
        <button onClick={onCancel} className="text-white/80 hover:text-white transition-colors">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="p-6 space-y-10">
        {/* Basic Details */}
        <div className="space-y-6">
          <h3 className="text-lg font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <span className="w-8 h-8 rounded-lg bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 flex items-center justify-center text-sm font-bold">1</span>
            Company Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-1">
              <label className="text-xs font-bold uppercase tracking-wider text-gray-500">Company Name</label>
              <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 outline-none" required />
            </div>
            <div className="space-y-1">
              <label className="text-xs font-bold uppercase tracking-wider text-gray-500">Tax Year</label>
              <input type="text" name="taxYear" value={formData.taxYear} onChange={handleChange} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-teal-500 outline-none" required />
            </div>
          </div>
        </div>

        {/* Registered Agent */}
        <div className="space-y-6 pt-8 border-t border-gray-100 dark:border-dark-700">
          <h3 className="text-lg font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <span className="w-8 h-8 rounded-lg bg-violet-100 dark:bg-violet-900/30 text-violet-600 dark:text-violet-400 flex items-center justify-center text-sm font-bold">2</span>
            Registered Agent Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="md:col-span-2 space-y-1">
              <label className="text-xs font-bold uppercase tracking-wider text-gray-500">Agent Name</label>
              <input type="text" name="raName" value={formData.raName} onChange={handleChange} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-violet-500 outline-none" required />
            </div>
            <div className="md:col-span-2 space-y-1">
              <label className="text-xs font-bold uppercase tracking-wider text-gray-500">Address</label>
              <input type="text" name="raAddress" value={formData.raAddress} onChange={handleChange} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-emerald-500 outline-none" required />
            </div>
            <div className="space-y-1">
              <label className="text-xs font-bold uppercase tracking-wider text-gray-500">City</label>
              <input type="text" name="raCity" value={formData.raCity} onChange={handleChange} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-emerald-500 outline-none" required />
            </div>
            <div className="space-y-1">
              <label className="text-xs font-bold uppercase tracking-wider text-gray-500">State</label>
              <input type="text" name="raState" value={formData.raState} onChange={handleChange} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-emerald-500 outline-none" required />
            </div>
            <div className="space-y-1">
              <label className="text-xs font-bold uppercase tracking-wider text-gray-500">Zip Code</label>
              <input type="text" name="raZipCode" value={formData.raZipCode} onChange={handleChange} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-600 bg-gray-50 dark:bg-dark-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-emerald-500 outline-none" required />
            </div>
          </div>
        </div>

        {/* Form Actions */}
        <div className="flex flex-col sm:flex-row justify-end gap-4 pt-10 border-t border-gray-100 dark:border-dark-700">
          <button type="button" onClick={onCancel} className="px-8 py-3 rounded-xl font-bold text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-dark-700 transition-all text-center text-sm">Cancel</button>
          <button type="button" onClick={() => onSave(formData, false)} disabled={isSubmitting} className="px-8 py-3 bg-gray-100 dark:bg-dark-700 text-gray-700 dark:text-gray-300 font-bold rounded-xl hover:bg-gray-200 dark:hover:bg-dark-600 transition-all flex items-center justify-center gap-2 disabled:opacity-50 text-sm">
            <FaSave /> Save as Draft
          </button>
          <button type="submit" disabled={isSubmitting} className="px-10 py-3 bg-gradient-to-r from-indigo-600 to-violet-600 text-white font-bold rounded-xl shadow-lg shadow-indigo-500/25 hover:shadow-xl hover:shadow-indigo-500/40 transition-all flex items-center justify-center gap-2 disabled:opacity-50 text-sm">
            {isSubmitting ? <><span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> Submitting...</> : <><FaFilePdf /> Submit Delaware LLC Checklist</>}
          </button>
        </div>
      </form>
    </div>
  );
};

export default DelawareLLCChecklistForm;
